"use strict";

const HardAssetInventorySetLocation = function () {
  const stringKey = "hard-asset-set-location";
  const headerInformation = "Location";
  let $page;

  var getStringKey = function () {
    return stringKey;
  };

  var getHeaderInformation = function () {
    return headerInformation;
  };

  var render = async function () {
    renderPageHtml();

    if (HardAssetInventoryModalController.isLineAsset()) {
      showLineLocation();
    } else {
      showPointLocation();
    }

    Form.initializeAndLoadListeners(
      $page,
      HardAssetInventoryModalController.getInventoryFormKey(),
      { isMultiPart: true },
    );
    loadListeners();
  };

  var renderPageHtml = function () {
    const html = nunjucks.render(
      "modals/hardAssetInventory/hardAssetInventorySetLocation.njk",
      getRenderProps(),
    );
    HardAssetInventoryModalController.renderPageContent(html);
    $page = $(".modal-dynamic-content");
    initializeAssociationDropdowns();
  };

  var initializeAssociationDropdowns = function () {
    const $associationSelects = $page.find(
      `select[name="associated-project"], select[name="associated-facility"]`,
    );
    if ($associationSelects.select2) {
      $associationSelects.select2();
    }
  };

  var rerenderLocationInfoFields = function () {
    HardAssetInventoryModalController.rerenderPageSection(
      $page,
      ".location-info-fields",
      "modals/hardAssetInventory/hardAssetInventorySetLocationInfoFields.njk",
      getRenderProps(),
    );
    initializeAssociationDropdowns();
  };

  var rerenderPointFields = function () {
    HardAssetInventoryModalController.rerenderPageSection(
      $page,
      ".location-point-fields",
      "modals/hardAssetInventory/hardAssetInventorySetLocationPointFields.njk",
      getRenderProps(),
    );
  };

  var getRenderProps = function () {
    const data = { ...HardAssetInventoryModalController.getInventoryForRender() };
    const latLng = parseLatLng(data);
    BmpFcsInventorySetLocation.handleAssociatedProjectProps(data);

    return {
      data,
      isLineAsset: HardAssetInventoryModalController.isLineAsset(),
      latitude: latLng?.lat,
      longitude: latLng?.lng,
      locationInfo: data.locationInfo,
      showMaintenanceZone: Tree.get("availableDataSortLayers")[0] === "maintenanceZones",
    };
  };

  var showPointLocation = function () {
    const latLng = getLatLng();
    setLastValidLatLng(latLng);
    ModalMap.removeMarkerLayer();
    LocationSelectionMap.configureLocationModalMapHandlers({
      checkNewMarkerHandler: HardAssetInventoryModalController.isNewAsset,
      newExistingMarkerHandler: loadExistingMarker,
      locationDataUpdateHandler: updateLocation,
      badLocationUpdateHandler: rerenderPointFields,
      createMarkerHandler: createNewMarker,
    });
    LocationSelectionMap.showLocationSelectionMap(!!latLng);
  };

  var setLastValidLatLng = function (latLng) {
    if (latLng) {
      Tree.set("modalMapSingleMarkerLastValidLatLng", latLng);
    }
  };

  var showLineLocation = function () {
    const geom = parseGeom(HardAssetInventoryModalController.getInventoryForRender().geom);
    if (geom) {
      LocationSelectionMap.showLineAssetLocation(geom);
    }
  };

  var loadExistingMarker = function () {
    const latLng = getLatLng();
    if (latLng) {
      const data = HardAssetInventoryModalController.getInventoryForRender();
      createMarker(latLng, data.rotationAzimuth, data.priority);
    }
  };

  var createNewMarker = function (newLatLng) {
    return createMarker(newLatLng, 0, false);
  };

  var createMarker = function (markerLatLng, outfallRotation, outfallPriority) {
    if (hasRotatingMarker()) {
      return ModalMap.createSingleRotatingOutFallMarker(
        markerLatLng,
        outfallRotation,
        outfallPriority,
      );
    }
    return ModalMap.createNewSingleMarker(markerLatLng);
  };

  var hasRotatingMarker = function () {
    return HardAssetInventoryConfig.hasRotatingMarker(
      HardAssetInventoryModalController.getAssetType(),
    );
  };

  var updateLocation = function (newLocationInfo, newLatLng) {
    setLastValidLatLng(newLatLng);

    HardAssetInventoryModalController.setFormDataField(
      "locationInfo",
      parseLocationInfo(newLocationInfo),
    );
    HardAssetInventoryModalController.setFormDataField("latitude", newLatLng.lat);
    HardAssetInventoryModalController.setFormDataField("longitude", newLatLng.lng);
    setAddressFields(newLocationInfo);
    setCentralizedBmpFields(newLocationInfo.centralizedBmps);

    rerenderLocationInfoFields();
    rerenderPointFields();
  };

  // The centralized BMPs of the new catchment are what a structural BMP can be paired with in a
  // treatment train, defaulting to the first of them while the asset is not paired yet
  var setCentralizedBmpFields = function (centralizedBmps) {
    if (centralizedBmps === undefined) {
      return;
    }

    HardAssetInventoryModalController.setFormDataField("centralizedBmps", centralizedBmps);

    const data = HardAssetInventoryModalController.getInventoryForRender();
    const unpairedBmps = HardAssetInventoryFields.getUnpairedCentralizedBmps(data);

    if (unpairedBmps.length > 0 && !data.tt) {
      HardAssetInventoryModalController.setFormDataField("ttFlowsTo", unpairedBmps[0].idbmp);
    }
  };

  // A location without an address of its own keeps the address already entered for the asset
  var setAddressFields = function (newLocationInfo) {
    for (const field of ["address", "city", "zip"]) {
      if (newLocationInfo[field] !== undefined) {
        HardAssetInventoryModalController.setFormDataField(field, newLocationInfo[field]);
      }
    }
  };

  var onLatLngInputChange = function () {
    const lat = $page.find(`input[name="latitude"]`).val();
    const lng = $page.find(`input[name="longitude"]`).val();

    if (lat && lng) {
      LocationSelectionMap.locationSelectionMapClick({ latlng: { lat, lng } });
    } else {
      rerenderPointFields();
    }
  };

  var onAssociatedProjectChange = function (e, selectedProjectId) {
    HardAssetAssociatedProject.applyProjectToInventory(selectedProjectId);
  };

  var onRotationAzimuthChange = function (e, rotationAzimuth) {
    const latLng = getLatLng();
    if (!hasRotatingMarker() || !latLng) {
      return;
    }

    ModalMap.removeMarkerLayer();
    const marker = createMarker(
      latLng,
      rotationAzimuth,
      HardAssetInventoryModalController.getInventoryForRender().priority,
    );
    ModalMap.setMarkerDragHandlers(marker, true);
  };

  var loadListeners = function () {
    $page.on("change", `input[name="latitude"], input[name="longitude"]`, onLatLngInputChange);
    $page.on("2N:FormInput", `input[name="rotation-azimuth"]`, onRotationAzimuthChange);
    $page.on("2N:FormInput", `input[name="use-manual-apn"]`, rerenderLocationInfoFields);
    $page.on("2N:FormInput", `[name="associated-project"]`, onAssociatedProjectChange);
  };

  var removeListeners = function () {
    $page.off("change", `input[name="latitude"], input[name="longitude"]`, onLatLngInputChange);
    $page.off("2N:FormInput", `input[name="rotation-azimuth"]`, onRotationAzimuthChange);
    $page.off("2N:FormInput", `input[name="use-manual-apn"]`, rerenderLocationInfoFields);
    $page.off("2N:FormInput", `[name="associated-project"]`, onAssociatedProjectChange);
  };

  var getLatLng = function () {
    return parseLatLng(HardAssetInventoryModalController.getInventoryForRender());
  };

  var parseLatLng = function (data) {
    if (data.latitude && data.longitude) {
      return { lat: data.latitude, lng: data.longitude };
    }
    if (data.isLineGeometry) {
      return null;
    }
    const geom = parseGeom(data.geom);
    return geom ? { lat: geom.coordinates[1], lng: geom.coordinates[0] } : null;
  };

  var parseGeom = function (geom) {
    return geom ? JSON.parse(geom) : null;
  };

  // The map returns the raw location layer columns, which the API normalizes for saved assets
  var parseLocationInfo = function (rawLocationInfo) {
    return {
      parcelApn: rawLocationInfo.parcelid ?? null,
      catchmentName: rawLocationInfo.catchid ?? null,
      receivingWaterName: rawLocationInfo.drains_to_rw ?? null,
      maintenanceZone: rawLocationInfo.maintenanceZone ?? null,
    };
  };

  var validate = function () {
    const warning = HardAssetInventoryModalController.getMissingRequiredFieldWarning();
    if (warning) {
      MessageModal.showSimpleWarningModal(warning);
      return false;
    }
    return true;
  };

  var cleanUp = function () {
    removeListeners();
    Tree.set("modalMapSingleMarkerLastValidLatLng", null);
    ModalMap.removeLineAssetLayer();
    LocationSelectionMap.hideLocationSelectionMap();
    $page.empty();
    return true;
  };

  return {
    getStringKey,
    getHeaderInformation,
    render,
    cleanUp,
    validate,
    parseLocationInfo,
    parseLatLng,
  };
};

module.exports = HardAssetInventorySetLocation();

const BmpFcsInventorySetLocation = require("../../bmpfcs/bmpFcsInventorySetLocation");
const Form = require("../../general/form");
const HardAssetAssociatedProject = require("./hardAssetAssociatedProject");
const HardAssetInventoryConfig = require("./hardAssetInventoryConfig");
const HardAssetInventoryFields = require("./hardAssetInventoryFields");
const LocationSelectionMap = require("../../mapFunctions/locationSelectionMap");
const ModalMap = require("../../mapFunctions/modalMap");
const Tree = require("../../tree");
const MessageModal = require("../../modals/messageModal");
const HardAssetInventoryModalController = require("../hardAssetInventoryModalController");
